import st from "@/styles/Ui.module.scss"
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import Tooltip from '@mui/material/Tooltip';
import {useState} from "react";
import copy from 'copy-to-clipboard';
import {isMobile} from 'react-device-detect';
import useCommon from "@/hooks/common.ts";
import Button from "@/ui/Button.tsx";
import MapIcon from "@/svg/MapIcon.tsx";


interface Props {
    office: any
    onClick?():void
    selected?:boolean
    show_map_btn?:boolean
    className?:string
}

const OfficeCard:React.FC<Props> = (props) => {
    
    const {
        central_office,
        secondary_office,
        intermediate_office,
        address,
        city_name,
        text_schedule,
        free_days,
        phone_numbers
    } = props.office
    
    const {
        onClick,
        selected,
        show_map_btn,
        className
    } = props
    
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    const [copied, setCopied] = useState(false);
    const c_hook = useCommon()
    const {t} = useTranslation()
    
    let off_statut = ""
    if(central_office) {
        off_statut = t("main_office")
    } else if (secondary_office) {
        off_statut = t("secondary_office")
    } else if(intermediate_office){
        off_statut = t("intermediate_office")
    }
    
    const handler = (nr:string) => {
        if(isMobile) {
            c_hook.handleTelTo(nr)
        } else {
            copy(nr)
            setCopied(true);
            
            setTimeout(() => {
                if(debug === "true") console.info("setInterval useIntervals")
                
                setCopied(false);
            }, 2000);
        }
    }
    
    return (
        <div
            className={clsx(
                st.office,
                selected && st.selected,
                className && className
            )}
            onClick={onClick}
        >
            <div className={st.top}>
                <span className={st.off_status}>
                    {off_statut}
                </span>
                
                <span className={st.off_city}>
                    {city_name}
                </span>
                
                <span className={st.off_address}>
                    {address}
                </span>
                
                <div className={st.off_schedule}>
                    <span>
                        {text_schedule}
                    </span>
                    
                    <span>
                        {free_days}
                    </span>
                </div>
                
                <div className={st.numbers}>
                    {Array.isArray(phone_numbers) && phone_numbers.length > 0 && phone_numbers.map((nr: any, i: number) => {
                        const numberElement = (
                            <span
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handler(nr.number);
                                }}
                                key={`number_${i}`}
                                className={st.number}
                            >
                      {nr.number}
                    </span>
                        );
                        
                        return isMobile ? numberElement : (
                            <Tooltip
                                title={copied ? t('copied') : t('copy_number')}
                                leaveTouchDelay={1000}
                                enterTouchDelay={0}
                                key={`number_${i}`}
                            >
                                {numberElement}
                            </Tooltip>
                        );
                    })}
                
                </div>
            </div>
            
            
            {show_map_btn && (
                <Button onClick={onClick} outlined className={st.show_on_map_btn}>
                    <MapIcon/>
                    {t("show_on_map")}
                </Button>
            )}
        
        </div>
    )
}

export default OfficeCard